export default (that) => [
  {
    field: 'orderGoodsNo',
    width: 40,
    align: 'center',
    type: 'seq',
    merge: true
  },
  {
    title: that.$l('INDEX.order_goods_label_orderGoodsNo') || '产品编号',
    field: 'orderGoodsNo',
    headerAlign: 'center',
    align: 'center',
    width: 140,
    mergeByKey: true,
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_goods_label_identifyGoodsNo') || '产品识别编号',
    field: 'identifyGoodsNo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
    merge: true,
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_goods_label_orderGoodsName') || '产品名称',
    field: 'orderGoodsDisplayName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 250,
    merge: true,
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_goods_label_qty') || '数量',
    field: 'qty',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    merge: true,
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_goods_label_isGroup') || '是否套装',
    field: 'v_isGroup',
    minWidth: 80,
    align: 'center',
    slots: { default: 'isGroup' }
  },
  {
    title: that.$l('INDEX.order_goods_label_inPackageQty') || '装箱入数',
    field: 'inPackageQty',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    merge: true,
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_goods_label_boxQty') || '箱数',
    field: 'boxQty',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    merge: true,
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_goods_label_price') || '价格',
    field: 'price',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    merge: true,
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_goods_label_subAmount') || '小计金额',
    field: 'subAmount',
    headerAlign: 'center',
    align: 'right',
    width: 100,
    merge: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.order_goods_label_salePrice') || '价格',
    field: 'salePrice',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    merge: true,
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_goods_label_subSaleAmount') || '售价小计',
    field: 'subSaleAmount',
    headerAlign: 'center',
    align: 'right',
    width: 100,
    merge: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.order_spec_label_spec_title') || '产品规格',
    align: 'center',
    children: [
      // {
      //   field: 'orderGoodsSpecNo',
      //   width: 40,
      //   align: 'center',
      //   type: 'seq',
      // },
      // {
      //   title: that.$l('INDEX.order_spec_label_orderGoodsSpecNo') || '产品规格编号',
      //   field: 'orderGoodsSpecNo',
      //   width: 150,
      // },
      {
        title:
          that.$l('INDEX.order_spec_label_orderGoodsSpecName') ||
          '规格名称',
        field: 'orderGoodsSpecName',
        headerAlign: 'center',
        align: 'center',
        minWidth: 90,
        showHeaderOverflow: true,
      },
      {
        title: that.$l('INDEX.order_spec_label_spec') || '产品规格',
        field: 'spec',
        headerAlign: 'center',
        align: 'center',
        width: 120,
        showHeaderOverflow: true,
        showOverflow: true,
        slots: {
          default: 'spec'
        }
      },
      {
        title: that.$l('INDEX.order_spec_label_spec_inGroupQty') || '规格数量',
        field: 'inGroupQty',
        headerAlign: 'center',
        align: 'center',
        showHeaderOverflow: true,
        width: 80
      },
      {
        title: that.$l('INDEX.order_spec_label_qty') || '数量',
        field: 'specQty',
        headerAlign: 'center',
        align: 'center',
        showHeaderOverflow: true,
        width: 80
      },
      // {
      //   title: that.$l('INDEX.order_spec_label_materialDesc') || '面料说明',
      //   field: 'materialDesc',
      //   headerAlign: 'center',
      //   align: 'left',
      //   minWidth: 250,
      //   showHeaderOverflow: true,
      //   showOverflow: true
      // }
      // {
      //   title: that.$l('INDEX.order_spec_label_accessoriesDesc') || '辅料说明',
      //   field: 'accessoriesDesc',
      //   headerAlign: 'center',
      //   align: 'left',
      //   width: 250,
      //   showHeaderOverflow: true,
      //   showOverflow: true
      // },
      // {
      //   title: that.$l('INDEX.order_spec_label_technologyDesc') || '工艺要求说明',
      //   field: 'technologyDesc',
      //   headerAlign: 'center',
      //   align: 'left',
      //   width: 250,
      //   showHeaderOverflow: true,
      //   showOverflow: true
      // },
      // {
      //   title: that.$l('INDEX.order_spec_label_smallPackageDesc') || '小包装说明',
      //   field: 'smallPackageDesc',
      //   headerAlign: 'center',
      //   align: 'left',
      //   width: 250,
      //   showHeaderOverflow: true,
      //   showOverflow: true
      // },
      // {
      //   title: that.$l('INDEX.order_spec_label_innerPackageDesc') || '内包装说明',
      //   field: 'innerPackageDesc',
      //   headerAlign: 'center',
      //   align: 'left',
      //   width: 250,
      //   showHeaderOverflow: true,
      //   showOverflow: true
      // }
    ]
  }
]
